import {takeEvery} from 'redux-saga/effects'

import {
  SP_SUBJ_CLASS_RESOURCES,
  SP_SUBJ_CLASS_WORK,
  SP_SUBJ_DAILY_SCHEDULES,
  SP_SUBJ_DETAIL,
  SP_SUBJ_LECTURE_INQUIRY,
  SP_SUBJ_LECTURE_INQUIRY_SEND,
  SP_SUBJ_LEGACY_OUTLINE,
  SP_SUBJ_LEGACY_OUTLINES,
  SP_SUBJ_LIST,
  SP_SUBJ_OUTLINE,
  SP_SUBJ_OUTLINE_SCHEDULE,
  SP_SUBJ_OUTLINE_WEEKLY,
  SP_SUBJ_RESOURCES,
  SP_SUBJ_SUBJECT_CLASSWORK,
  SP_SUBJ_SUBJECT_CLASSWORK_DETAIL,
  SP_SUBJ_YEARLY_SCHEDULES,
} from '../../Actions/SpSubject/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

/**
 * Parent/student subject, outline, classwork and resource pages, the lecture
 * inquiry chat and the family daily / yearly schedule lists.
 */
function* dataSaga() {
  yield takeEvery(SP_SUBJ_LIST, fetchData)
  yield takeEvery(SP_SUBJ_DETAIL, fetchData)
  yield takeEvery(SP_SUBJ_RESOURCES, fetchData)
  yield takeEvery(SP_SUBJ_CLASS_RESOURCES, fetchData)
  yield takeEvery(SP_SUBJ_OUTLINE, fetchData)
  yield takeEvery(SP_SUBJ_OUTLINE_SCHEDULE, fetchData)
  yield takeEvery(SP_SUBJ_OUTLINE_WEEKLY, fetchData)
  yield takeEvery(SP_SUBJ_LEGACY_OUTLINES, fetchData)
  yield takeEvery(SP_SUBJ_LEGACY_OUTLINE, fetchData)
  yield takeEvery(SP_SUBJ_CLASS_WORK, fetchData)
  yield takeEvery(SP_SUBJ_SUBJECT_CLASSWORK, fetchData)
  yield takeEvery(SP_SUBJ_SUBJECT_CLASSWORK_DETAIL, fetchData)
  yield takeEvery(SP_SUBJ_LECTURE_INQUIRY, fetchData)
  yield takeEvery(SP_SUBJ_LECTURE_INQUIRY_SEND, fetchData)
  yield takeEvery(SP_SUBJ_DAILY_SCHEDULES, fetchData)
  yield takeEvery(SP_SUBJ_YEARLY_SCHEDULES, fetchData)
}

export default dataSaga
